import { API_URL } from '../config/connect';

const getAnnouncementById = async (id) => {
    try {
        const accessToken = localStorage.getItem("access_token");
        const headers = {
            'Accept': 'application/json',
        };
        
        if (accessToken) {
            headers['Authorization'] = `Bearer ${accessToken}`;
        }

        const response = await fetch(`${API_URL}/api/v1/announcement/${id}`, {
            method: 'GET',
            headers: headers,
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} - ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching announcement:', error);
        throw error;
    }
};

export default getAnnouncementById;